import { IconProps } from "./types";

export default function IcoUser({
	color = "#707070",
	width = "18",
	height = "20"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 18 20"
			fill="none"
		>
			<g clipPath="url(#clip0_636_3453)">
				<path
					d="M8.75 10C10.0761 10 11.3479 9.47322 12.2855 8.53553C13.2232 7.59785 13.75 6.32608 13.75 5C13.75 3.67392 13.2232 2.40215 12.2855 1.46447C11.3479 0.526784 10.0761 0 8.75 0C7.42392 0 6.15215 0.526784 5.21447 1.46447C4.27678 2.40215 3.75 3.67392 3.75 5C3.75 6.32608 4.27678 7.59785 5.21447 8.53553C6.15215 9.47322 7.42392 10 8.75 10ZM6.96484 11.875C3.11719 11.875 0 14.9922 0 18.8398C0 19.4805 0.519531 20 1.16016 20H16.3398C16.9805 20 17.5 19.4805 17.5 18.8398C17.5 14.9922 14.3828 11.875 10.5352 11.875H6.96484Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_636_3453">
					<path d="M0 0H17.5V20H0V0Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
